<nav>
  <ul class="m-0">
    <li *ngIf="level !== 0" (click)="goBack()"><i class="fas fa-angle-left"></i></li>
    <ng-container *ngFor="let item of navItems">
      <li *ngIf="item.label && item.shouldDisplay" (click)="select(item)"
          [ngClass]="{ selected: isItemSelected(item.key) }">
        {{ item.label | translate }}
      </li>
    </ng-container>
  </ul>
</nav>
